/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment/moment';

export default class BulkWriteoffRoute extends Route {
  controllerName = 'admin/finance/ledger-items/item';
  templateName = 'admin/finance/ledger-items/item';

  // Services
  @service
  store;

  model(params) {
    let year = moment().year();
    return hash({
      ledgerItems: this.store.query('finance/ledger-item', {
        year: params.year,
      }),
      lineItems: this.store.query('finance/line-item', {
        year: params.year,
        include: 'accounts',
      }),
      // Transactions are used to calculate "refundable amounts".
      transactions: this.store.query('finance/transaction', {
        year: params.year,
      }),
      // Groups are used for filtering
      groups: this.store.query('group', { year }),
      bulkWriteoff: true,
      year: params.year,
    });
  }

  setupController() {
    super.setupController(...arguments);
    this.controller.set(
      'hideArchivedLineItems',
      this.controller.get('personOptions.hideArchivedLineItems'),
    );
  }
}
